import React, { InputHTMLAttributes, ReactElement, useState } from "react";

import { Link } from "react-router-dom";
import { Logo, MenuFooter } from "../../assets";
import { footerItems } from "../../core/utils";
import {Dialog, Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { HeaderItem } from "./header_item";
import { ProfileCard } from "../components";
import { connect } from "react-redux";
import { logout } from "../../core/service";
 
interface Props extends InputHTMLAttributes<HTMLInputElement> {
  userData?: any;
}
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const Footer = ({ userData }: Props) : ReactElement => {
  const [showUpdateMOdal, setShowUpdateMOdal] = useState(false);

  const cuurentUrl = window.location.pathname;
  return (
    <div className="footer rtl hide-desktop">
      <ul className="flex-container flex-center ">


                        {footerItems?.filter((item: any ) => item.displayInModal !== true).map((item, index) => {
                            return (
                              <li className={cuurentUrl === item?.path ? "active-item" : ""}>
                              <span className={cuurentUrl === item?.path ? "border-top" : "" }></span>
                                <Link to={item?.path}>
                                  {cuurentUrl === item?.path ? item?.activeIcon 
                                  : item?.icon
                                  } 
                                </Link>
                              {cuurentUrl === item?.path && 
                              <span className="title" >{item?.name} </span> 
                        }
                              </li>
                            )
                          })}
                                  
                                  <li onClick={() => setShowUpdateMOdal(!showUpdateMOdal) }>
                                      <MenuFooter/>
                                  </li>
                                </ul>
                                <Dialog


                                className="menu-dialog-container"
                                TransitionComponent={Transition}

                                open={showUpdateMOdal} onClose={() => setShowUpdateMOdal(!showUpdateMOdal) }
                                aria-labelledby="menu-dialog">

                                <div className="menu-dialog">
                                    <div className="menu-dialog-headline"><span className="rectangle"></span></div>

                                    <div className="menu-dialog-logo">
                                      <img src={Logo} alt="هامرز"/>
                                    </div>
                                    <div className="menu-dialog-border">
                                      
                                    </div>

<div className="d-flex justify-content-between align-items-center">
<ProfileCard  isMini image={userData?.picture} name={`${userData?.first_name} ${userData?.last_name}`} />
  <span className="log-out" onClick={()=>logout()}>خروج</span>
  </div>                                  
                                    <div className="menu-dialog-border">
                                      
                                      </div>
                                    {footerItems?.map((item, index) => {
          return (
            <HeaderItem
              name={item?.name}
              icon={item?.icon}
              link={item.path}
              // subMenu={item?.items}
              key={index}
              userProfile
            />
          )
        })}

                                </div>

                            </Dialog>
    </div>
  );
};
const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  };
};
export default connect(mapStateToProps)(Footer);
